export default __webpack_public_path__ + "static/media/grafema_gim-tonico_15.27e6608c.jpg";